var win = $(window);
var doc = $(document);

var forms = {};
forms = {
  defaults: {
    // Constant Variables
  },
  onInit: function() {
    var vm = this;

    vm.sendCustomForm({
      form      : $('form#press-form'),
      receiver  : 'emily@thequickflick.com.au',
      subject   : 'TQF Press and Media Enquiries'
    });
    vm.sendCustomForm({
      form      : $('form#wholesale'),
      receiver  : 'wholesale@thequickflick.com.au',
      subject   : 'TQF Wholesale Enquiries'
    });
    vm.sendCustomForm({
      form      : $('form#influencer'),
      receiver  : 'alicia@thequickflick.com.au',
      subject   : 'TQF Influencer Enquiries'
    });
  },
  onReady: function(e) {
    var vm = this;

    vm.onInit();
  },
  onLoad: function(e) {},
  onResize: function(e) {},
  onScroll: function(e) {},
  sendCustomForm: function(params) { 
    params.form.submit(function(e) {
      e.preventDefault();
      var msg = "",
          fields = [];
      if( params.form.is( $('form#press-form') ) ) {
        /** Set fields for Press and Media form */ 
        fields = [
          { label: 'Name', value: params.form.find('#contactFormName').val() },
          { label: 'Business Name', value: params.form.find('#contactFormBusinessName').val() },
          { label: 'Email', value: params.form.find('#contactFormEmail').val() },
          { label: 'Message', value: params.form.find('#contactFormMessage').val() },
        ]
      } else if( params.form.is( $('form#wholesale') ) ) {
        fields = [
          { label: 'First Name', value: params.form.find('#contactFormFirstName').val() },
          { label: 'Last Name', value: params.form.find('#contactFormLastName').val() },
          { label: 'Company Name', value: params.form.find('#contactFormCompanyName').val() },
          { label: 'Phone/Mobile', value: params.form.find('#contactFormTelephone').val() },
          { label: 'Email', value: params.form.find('#contactFormEmail').val() },
          { label: 'Address', value: params.form.find('#contactFormAddress').val() },
          { label: 'Country', value: params.form.find('#contactFormCountry').val() },
          { label: 'State/Territory', value: params.form.find('#contactFormState').val() },
          { label: 'Postcode', value: params.form.find('#contactFormPostcode').val() },
          { label: 'Note', value: params.form.find('#contactFormMessage').val() },
        ] 
      } else if( params.form.is( $('form#influencer') ) ) {
        fields = [
          { label: 'Name', value: params.form.find('#contactFormName').val() },
          { label: 'Email', value: params.form.find('#contactFormEmail').val() },
          { label: 'Social Accounts', value: params.form.find('#contactFormOtherSocial').val() },
          { label: 'Message', value: params.form.find('#contactFormMessage').val() },
        ]
      }
      /** Render email body */ 
      msg += "<table>";
        msg += "<tbody>";
        fields.map(function(i) {
          msg += "<tr>";
            msg += "<th align='left'>" + i.label + ":</th>";
            msg += "<td>" + i.value + "</td>";
          msg += "</tr>";
        })
        msg += "</tbody>";
      msg += "</table>";

      Email.send({
        SecureToken : "6427b0d7-35b0-4b75-a140-1a5d5ceadef4",
        Host: "smtp.gmail.com",
        Username: "info.thequickflick@gmail.com",
        Password: "Codein06",
        To: params.receiver,
        From: "hello@thequickflick.com.au",
        Subject: params.subject,
        Body: msg
      }).then(function() {
        $('.custom-form-container').html("<p>Thanks for contacting us! We'll get back to you as soon as possible.</p>")
      });
    })
  }
};

doc.ready(function() {
  forms.onReady();
});

win.on("load", function() {
  forms.onLoad();
});

win.resize(function() {
  forms.onResize();
});

win.scroll(function() {
  forms.onScroll();
});
